import React, {FC, memo, useCallback, useEffect, useState} from 'react';
import {AnnouncementsPopUp} from './announcementsPopUp/AnnouncementsPopUp';
import {AnnouncementType} from '../../../types/AnnouncementType';
import {dismissAnnouncement} from '../../../redux/slices/campusLocationSlice';
import {useAppDispatch} from '../../../redux/hooks';

interface AnnouncementsManagerProps {
  announcementsData: AnnouncementType[];
}

export const AnnouncementsManager: FC<AnnouncementsManagerProps> = memo(
  ({announcementsData}) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [visible, setVisible] = useState(false);
    const dispatch = useAppDispatch();

    const fullScreenAnnouncements = announcementsData.filter((a) => {
      return a.isFullScreenAdEnabled && !a.isDismissed;
    });

    useEffect(() => {
      if (fullScreenAnnouncements.length > 0) {
        setCurrentIndex(0);
        setVisible(true);
      }
    }, [announcementsData]);

    const current = fullScreenAnnouncements[currentIndex];

    const handleClose = useCallback(() => {
      dispatch(dismissAnnouncement({announcementId: current.announcementId}));
      if (currentIndex < fullScreenAnnouncements.length - 1) {
        setCurrentIndex((prev) => prev + 1);
      } else {
        setVisible(false);
      }
    }, [
      current?.announcementId,
      currentIndex,
      dispatch,
      fullScreenAnnouncements.length,
    ]);

    if (!visible || fullScreenAnnouncements.length === 0) {
      return null;
    }

    return (
      <AnnouncementsPopUp
        isModalVisible={visible}
        onModalClose={handleClose}
        title={current?.fullScreenHeader}
        body={current?.fullScreenBody}
        coverImg={current?.fullScreenImageUrl}
        btnText={current?.fullScreenButtonTitle}
        btnLink={
          current?.fullScreenExternalLink || current?.fullScreenPdfAttachUrl
        }
      />
    );
  },
);
